module.exports = __webpack_public_path__ + "img/single_aircraft.9dc27dbf.svg";